<div class="modal-header" id="contract-modal-title">
    <h3 class="modal-title" translate="NOTIFICATION_DETAILS_DETAIL_LINKS_CONTRACT_INFO_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <pace-contract-information [model]="notification.contract"></pace-contract-information>
</div>
